import { render } from "./RussiaLimitations.vue?vue&type=template&id=0eaba6f6&scoped=true&ts=true"
import script from "./RussiaLimitations.vue?vue&type=script&lang=ts"
export * from "./RussiaLimitations.vue?vue&type=script&lang=ts"

import "./RussiaLimitations.vue?vue&type=style&index=0&id=0eaba6f6&scoped=true&lang=scss"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0eaba6f6"]])

export default __exports__